module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-action', [(_vm.args.agree) ? _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-shield")]) : _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("mdi-shield-outline")])], 1), _c('v-list-tile-content', [(_vm.args.agree) ? _c('v-list-tile-title', [_vm._v("The legislature agreed to a veto")]) : _c('v-list-tile-title', [_vm._v("The president denied a veto")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cdf91ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/events/events/veto/preview.vue
// module id = 340
// module chunks = 0